import _ from 'lodash';
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError, AxiosInstance } from 'axios';
import toastr from '../components/toastr';
import config from '../config';
import store from '../store';
import history from '../history';
import AuthService from './AuthService';

interface ApiService extends AxiosInstance {
  getPageConfig?: (pageName: string, params: object) => Promise<any>;
  getReportData?: (pageName: string, options: any) => Promise<any>;
}

const client: ApiService = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true, // allow cookies
  // validateStatus: () => true,
});

client.interceptors.request.use((axiosConfig: AxiosRequestConfig) => {
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');

  if (token) {
    if (!axiosConfig.headers) {
      axiosConfig.headers = {};
    }
    axiosConfig.headers.authorization = token;
  }

  // encode hash in url
  axiosConfig.url = axiosConfig.url!.replace(/#/g, '%23');
  return axiosConfig;
});

client.interceptors.response.use(
  (response: AxiosResponse) => response,
  (err: AxiosError) => {
    if (_.get(err, 'response.data.noAuth')) {
      toastr.error('Session Expired', 'Log back in.', { timeOut: 5000 });
      AuthService.removeToken();
      history.push('/login');
    }

    if (_.get(err, 'response.data.error') === 'max users') {
      toastr.error('Max Users', 'All licenses are in use! Please close inactive terminals.', { timeOut: 5000 });

      err.message = 'max users';
      return Promise.reject(err);
    }

    return Promise.reject(err);
  }
);

client.getPageConfig = (pageName, params = {}) => {
  return client.get(`page/${pageName}`, { params }).then((response: AxiosResponse) => {
    return Promise.resolve(response.data);
  });
};

client.getReportData = (pageName, options = {}) => {
  const defaults = {
    branchID: store.getState().app.branch.id,
    reportOptions: [],
    useCache: false,
  };

  return client
    .post(`report/data/${pageName}`, _.defaults(options, defaults))
    .then(({ data }: AxiosResponse) => {
      data = data.trimRight();
      if (!data || data === 'NO.DATA' || data === 'no data') {
        return Promise.resolve([]);
      }

      return Promise.resolve(
        data
          .trimRight()
          .split('\n')
          .map((row: string) => row.split('ý'))
      );
    })
    .catch((err: AxiosError) => {
      if (err.response) {
        const { data } = err.response;
        return Promise.reject(new Error(_.get(data, 'error', data)));
      }

      return Promise.reject(err);
    });
};

export default client;
